export interface ProfileResidenceResponse {
  id: number;
  cid: string;
  residenceId: number;
  ownershipStatusId: number;
  ownershipStatusDescription: string;
  monthlyPayment: number;
  activeStatus: boolean;
  residenceType?: string;
  insertTs: string;
  modifiedTs: string;
}

export interface ProfileResidenceUpdateRequest {
  cid: string;
  id?: number;
  residenceId?: number;
  ownershipStatusId?: number;
  monthlyPayment?: number;
}

export interface ProfileEmailGetRequest {
  customerId: number;
}
export interface ProfileEmailGetResponse {
  customerId: number;
  email: string;
}
export interface ProfileEmailUpdateRequest {
  customerId: number;
  reqBody: {
    add: false;
    email: string;
    update: true;
  };
}

export interface PaperlessEnrollmentPutRequest {
  customerId: number;
  reqBody: {
    enroll: boolean;
  };
}

export interface PaperlessEnrollmentPutResponse {
  status: 'success' | 'failure';
}

export interface ProfileResidenceModalData extends ProfileResidenceUpdateRequest {
  profileType: 'residence';
}

export enum ResidenceOwnershipValue {
  RESIDENCE_RENT = 5,
  RESIDENCE_PAY_MORTGAGE = 6,
  RESIDENCE_NO_MORTGAGE = 7,
  RESIDENCE_OTHER = 8,
}

export enum ResidenceOwnershipLabel {
  RESIDENCE_RENT = 'Rent',
  RESIDENCE_PAY_MORTGAGE = 'Own and pay mortgage',
  RESIDENCE_NO_MORTGAGE = 'Fully own with no mortgage',
  RESIDENCE_OTHER = 'Other',
}

export const findResidenceOwnershipStatusById = (id: number) => {
  let statusId = id.toString();
  const statusObj = {
    '5': ResidenceOwnershipLabel.RESIDENCE_RENT,
    '6': ResidenceOwnershipLabel.RESIDENCE_PAY_MORTGAGE,
    '7': ResidenceOwnershipLabel.RESIDENCE_NO_MORTGAGE,
    '8': ResidenceOwnershipLabel.RESIDENCE_OTHER,
  };
  return statusObj[statusId];
};
